import { render, staticRenderFns } from "./directors.vue?vue&type=template&id=d78bcc12&scoped=true"
import script from "./directors.vue?vue&type=script&lang=js"
export * from "./directors.vue?vue&type=script&lang=js"
import style0 from "./directors.vue?vue&type=style&index=0&id=d78bcc12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78bcc12",
  null
  
)

export default component.exports